import { type UpdateResolver } from "@urql/exchange-graphcache";
import { gql } from "urql";

import { type DeleteInvitationPayload, type Maybe } from "@/gql/graphql";

type Result = Maybe<{
  deleteInvitation: Maybe<DeleteInvitationPayload>;
}>;

const updater: UpdateResolver<Result, null> = (result, _args, cache) => {
  if (result?.deleteInvitation?.invitation) {
    cache.updateQuery(
      {
        query: gql`
          query DeleteInvitationUpdate($organizationId: String!) {
            organization(id: $organizationId) {
              id
              invitations {
                nodes {
                  id
                }
              }
            }
          }
        `,
        variables: {
          organizationId: result.deleteInvitation.invitation.organizationId,
        },
      },
      (data) => {
        data.organization.invitations.nodes =
          data.organization.invitations.nodes.filter(
            (x: { id: string }) =>
              x.id !== result.deleteInvitation?.invitation?.id,
          );
        return data;
      },
    );
  }
};

export const deleteInvitation = updater as unknown as UpdateResolver;
